module.exports = __webpack_public_path__ + "application/directives/svg-image/resync-svg/resync-svg.template.html";